import React from 'react';

/**
 * Compact Pinterest board dropdown used on generated-post cards.
 *
 * Props:
 *  boards     – array of { id, name }, or undefined while still loading
 *  value      – selected board id
 *  onChange   – (boardId) => void
 *  isDarkMode – bool
 *  disabled   – bool
 */
const PinterestBoardSelect = ({ boards, value, onChange, isDarkMode, disabled = false }) => {
  const loading = boards === undefined;
  const placeholder = loading
    ? 'Loading boards...'
    : boards.length ? 'Select a board' : 'No boards found on this account';

  return (
    <div className="flex items-center gap-2 mb-2">
      <label className={`text-xs font-semibold whitespace-nowrap ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
        Pinterest board
      </label>
      <select
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled || loading || !boards.length}
        className={`flex-1 min-w-0 text-xs px-2 py-1.5 rounded-lg border outline-none disabled:opacity-60 ${
          isDarkMode ? 'bg-gray-800 border-gray-600 text-gray-200' : 'bg-white border-gray-300 text-gray-800'
        }`}
      >
        <option value="">{placeholder}</option>
        {(boards || []).map((board) => (
          <option key={board.id} value={board.id}>{board.name}</option>
        ))}
      </select>
    </div>
  );
};

export default PinterestBoardSelect;
